import * as o from "react";
import s from "../lib/IconBase.es.js";
import a from "../defs/CursorText.es.js";
const r = o.forwardRef((e, t) => /* @__PURE__ */ o.createElement(s, { ref: t, ...e, weights: a }));
r.displayName = "CursorTextIcon";
const n = r;
export {
  n as CursorText,
  r as CursorTextIcon
};
